import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_ENABLE_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_POST_EMPLOYER_BY_ID_ENABLE, KEY_POST_EMPLOYER_BY_ID_ENABLE } from '../constants';
import { MOCK_RESPONSE_POST_EMPLOYER_BY_ID_ENABLE } from '../mocks';
import { Employer } from '../types';

type RequestEmployerByIdEnable = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_ENABLE_PATH_KEY
>['request']['path'];

type ResponseEmployerByIdEnable = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_ENABLE_PATH_KEY
>['response']['body'];

export type CallParamsGetEmployerByIdEnable = Omit<RequestEmployerByIdEnable, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetEmployerByIdEnable = ResponseEmployerByIdEnable;

type CallErrorGetEmployerByIdEnable = GenericApiError;

type CallSelectorsGetEmployerByIdEnable = {
  employer: Employer | null;
};

export const postEmployerByIdEnableCall = createGeneralCall<
  CallParamsGetEmployerByIdEnable,
  CallResponseGetEmployerByIdEnable,
  CallErrorGetEmployerByIdEnable,
  CallSelectorsGetEmployerByIdEnable
>({
  id: KEY_POST_EMPLOYER_BY_ID_ENABLE,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_EMPLOYER_BY_ID_ENABLE(org, payload.employeeId);
    },
  method: 'post',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_EMPLOYER_BY_ID_ENABLE : undefined,
  selectors: {
    employer: ({ selectors }) =>
      createSelector(selectors.response, res => (res as Employer) || null),
  },
});
